import type { WixCodeApiFactoryArgs } from '@wix/thunderbolt-symbols'
import createWixData from '@wix/wix-data-platformized-client'
import type { DataWixCodeSdkSiteConfig } from '..'
import { namespace } from '..'

const DATA_BINDING_APP_DEF_ID = 'dataBinding'

export function DataSdkFactory({
	featureConfig,
	platformUtils: { sessionService },
	appEssentials,
	platformEnvData: { site, session },
	appDefinitionId,
	blocksAppsUtils,
}: WixCodeApiFactoryArgs<DataWixCodeSdkSiteConfig>) {
	const authHeaderProvider = {
		get() {
			const { isRunningInDifferentSiteContext } = session
			const appInstance = sessionService.getInstance(appDefinitionId)
			const isPreviewExpEnabled = blocksAppsUtils.isFixWixDataInstanceForBlocksPreviewExperimentOpen()
			const cmsStandaloneEnabled = Boolean(site.experiments['specs.thunderbolt.cmsStandalone'])

			if (
				(isPreviewExpEnabled && isRunningInDifferentSiteContext) ||
				(blocksAppsUtils.isBlocksApp(appDefinitionId) &&
					blocksAppsUtils.canAppInstanceBeUsedForAuthorization(appInstance)) ||
				(cmsStandaloneEnabled && appDefinitionId === DATA_BINDING_APP_DEF_ID)
			) {
				if (!appInstance) {
					throw new Error(`No app instance found for appDefinitionId: ${appDefinitionId}`)
				}

				return appInstance
			}

			return sessionService.getWixCodeInstance()
		},
	}

	const useCloudDataUrlWithExternalBaseUrl = Boolean(
		site.experiments['specs.thunderbolt.UseCloudDataUrlWithBaseExternalUrl']
	)

	const { gridAppId, environment, cloudDataUrl, cloudDataUrlWithExternalBase } = featureConfig

	const { httpClient } = appEssentials

	return {
		[namespace]: createWixData({
			cloudDataUrl: useCloudDataUrlWithExternalBaseUrl ? cloudDataUrlWithExternalBase : cloudDataUrl,
			httpClient,
			gridAppId,
			environment,
			authHeader: authHeaderProvider,
		}),
	}
}
